package io.horion.auth.presentation.ui.components.auth

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.boxShadow
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.fa.FaSpinner
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.auth.presentation.ui.theme.AuthTheme
import io.horion.auth.presentation.ui.theme.AuthTypography
import org.jetbrains.compose.web.css.*

@Composable
fun AuthButton(
    text: String,
    onClick: () -> Unit,
    loading: Boolean = false,
    disabled: Boolean = false,
    modifier: Modifier = Modifier
) {
    val colorMode = ColorMode.current
    val colors = AuthTheme.colors(colorMode)
    var isHovered by remember { mutableStateOf(false) }

    val isInactive = disabled || loading

    Box(
        modifier = modifier
            .fillMaxWidth()
            .padding(16.px)
            .borderRadius(12.px)
            .backgroundColor(
                when {
                    isInactive -> colors.secondary
                    isHovered  -> colors.primary
                    else       -> colors.primary
                }
            )
            .styleModifier {
                boxShadow(
                    if (isHovered && !isInactive)
                        "0 8px 24px rgba(0, 51, 102, 0.35)"
                    else
                        "0 2px 8px rgba(0, 51, 102, 0.15)"
                )
                if (isInactive) property("opacity", "0.6")
            }
            .cursor(if (isInactive) Cursor.NotAllowed else Cursor.Pointer)
            .onClick { if (!isInactive) onClick() }
            .onMouseEnter { if (!isInactive) isHovered = true }
            .onMouseLeave { isHovered = false }
            .transition(Transition.of("all", 0.2.s, AnimationTimingFunction.EaseOut)),
        contentAlignment = Alignment.Center
    ) {
        if (loading) {
            FaSpinner(
                modifier = Modifier
                    .fontSize(20.px)
                    .color(colors.onPrimary)
                    .styleModifier { property("animation", "spin 1s linear infinite") }
            )
        } else {
            SpanText(
                text,
                modifier = Modifier
                    .color(colors.onPrimary)
                    .fontWeight(FontWeight.SemiBold)
                    .fontSize(AuthTypography.body)
            )
        }
    }
}